const LangMyRewards = {
	"myRewards._title": ["MY REWARDS", "រង្វាន់​​ខ្ញុំ"],
	"myRewards.header._validUntil": ["VALIDITY UNTIL", "សុពលភាព​រហូត​ដល់​"],
	"myRewards.header._rewards": ["REWARDS", "រង្វាន់​"],
	"myRewards.header._to": ["To", "ទៅ​កាន់​"],
	"myRewards.body._noAvailableRecord": [
		"You don't have any earned Rewards at the moment.",
		"ខណៈ​នេះលោក​អ្នក​ ពុំ​ទាន់មាន​រង្វាន់​ទេ",
	],
}

export default LangMyRewards



// WEBPACK FOOTER //
// ./src/resources/modules/LangMyRewards.js